<script setup>
// Aresta customizada do Vue Flow — desenha a conexão e um botão "X" no meio para
// desconectar os nós. Permite remover a ligação e reconectar em outro nó.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  useVueFlow,
} from '@vue-flow/core';

const props = defineProps({
  id: { type: String, required: true },
  sourceX: { type: Number, required: true },
  sourceY: { type: Number, required: true },
  targetX: { type: Number, required: true },
  targetY: { type: Number, required: true },
  sourcePosition: { type: String, default: 'bottom' },
  targetPosition: { type: String, default: 'top' },
  markerEnd: { type: String, default: '' },
  style: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const { removeEdges } = useVueFlow();

const path = computed(() =>
  getBezierPath({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    sourcePosition: props.sourcePosition,
    targetX: props.targetX,
    targetY: props.targetY,
    targetPosition: props.targetPosition,
  })
);
const edgePath = computed(() => path.value[0]);
const labelX = computed(() => path.value[1]);
const labelY = computed(() => path.value[2]);

const remove = () => removeEdges(props.id);
</script>

<template>
  <BaseEdge :id="id" :path="edgePath" :marker-end="markerEnd" :style="style" />
  <EdgeLabelRenderer>
    <button
      class="nodrag nopan absolute w-[18px] h-[18px] flex items-center justify-center p-0 rounded-full bg-n-ruby-9 text-white border-[1.5px] border-white shadow opacity-85 pointer-events-auto transition hover:opacity-100 hover:scale-110 cursor-pointer"
      :style="{
        transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
      }"
      :title="t('CHATBOT.edge.disconnect')"
      @click="remove"
    >
      <svg
        class="w-[10px] h-[10px]"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        stroke-width="2.4"
      >
        <path stroke-linecap="round" d="M4 4l8 8M12 4l-8 8" />
      </svg>
    </button>
  </EdgeLabelRenderer>
</template>
